import { useEffect, useState } from 'react';
import { api } from '../../../api/client';

export default function TicketsPage() {
  const [tickets, setTickets] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    title: '',
    description: '',
    priority: 'NORMAL',
    category: 'OTHER',
  });

  const fetchTickets = () => {
    const params: Record<string, string> = {};
    if (filterStatus) params.status = filterStatus;
    api.get('/api/tickets', { params }).then((d) => {
      setTickets(d as any[]);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchTickets();
  }, [filterStatus]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/api/tickets', form);
    setShowForm(false);
    setForm({ title: '', description: '', priority: 'NORMAL', category: 'OTHER' });
    fetchTickets();
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Cargando...</div>;

  return (
    <div style={{ minHeight: '100vh' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 24,
        }}
      >
        <h1 style={{ fontSize: 28, fontWeight: 700, color: '#1a1c2c' }}>
          🎫 Sistema de Tickets / Incidencias
        </h1>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            background: 'var(--primary-gradient)',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: 8,
            border: 'none',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          + Nuevo Ticket
        </button>
      </div>

      <div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
        {['', 'OPEN', 'IN_PROGRESS', 'RESOLVED', 'CLOSED'].map((s) => (
          <button
            key={s}
            onClick={() => setFilterStatus(s)}
            style={{
              padding: '6px 16px',
              borderRadius: 20,
              border: 'none',
              cursor: 'pointer',
              fontWeight: 500,
              fontSize: 13,
              background: filterStatus === s ? 'var(--primary-gradient)' : '#f0f0f0',
              color: filterStatus === s ? '#fff' : '#666',
            }}
          >
            {s === ''
              ? 'Todas'
              : s === 'OPEN'
                ? 'Abiertas'
                : s === 'IN_PROGRESS'
                  ? 'En Progreso'
                  : s === 'RESOLVED'
                    ? 'Resueltas'
                    : 'Cerradas'}
          </button>
        ))}
      </div>

      {showForm && (
        <form
          onSubmit={handleSubmit}
          style={{
            background: '#fff',
            borderRadius: 12,
            padding: 20,
            marginBottom: 24,
            maxWidth: 500,
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          }}
        >
          <div style={{ marginBottom: 12 }}>
            <input
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              placeholder="Título del reporte"
              required
              style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <textarea
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              placeholder="Describe el problema o solicitud"
              required
              rows={4}
              style={{
                width: '100%',
                padding: 10,
                borderRadius: 8,
                border: '1px solid #ddd',
                resize: 'vertical',
              }}
            />
          </div>
          <div
            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}
          >
            <select
              value={form.priority}
              onChange={(e) => setForm({ ...form, priority: e.target.value })}
              style={{ padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            >
              <option value="LOW">Baja</option>
              <option value="NORMAL">Normal</option>
              <option value="HIGH">Alta</option>
              <option value="URGENT">Urgente</option>
            </select>
            <select
              value={form.category}
              onChange={(e) => setForm({ ...form, category: e.target.value })}
              style={{ padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            >
              <option value="TECHNICAL">Técnico</option>
              <option value="ACADEMIC">Académico</option>
              <option value="ADMINISTRATIVE">Administrativo</option>
              <option value="OTHER">Otro</option>
            </select>
          </div>
          <button
            type="submit"
            style={{
              background: 'var(--primary-color)',
              color: '#fff',
              padding: '10px 20px',
              borderRadius: 8,
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Crear Ticket
          </button>
        </form>
      )}

      <div style={{ display: 'grid', gap: 10 }}>
        {tickets.map((t: any) => (
          <div
            key={t.id}
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 16,
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                <span style={{ fontWeight: 600 }}>{t.title}</span>
                <span
                  style={{
                    padding: '2px 8px',
                    borderRadius: 4,
                    fontSize: 11,
                    background:
                      t.priority === 'URGENT'
                        ? '#ff2d5533'
                        : t.priority === 'HIGH'
                          ? '#ff5e3a33'
                          : t.priority === 'NORMAL'
                            ? '#2196f333'
                            : '#666633',
                    color:
                      t.priority === 'URGENT'
                        ? '#ff2d55'
                        : t.priority === 'HIGH'
                          ? '#ff5e3a'
                          : t.priority === 'NORMAL'
                            ? '#2196f3'
                            : '#999',
                  }}
                >
                  {t.priority}
                </span>
              </div>
              <p style={{ margin: 0, fontSize: 13, color: '#888' }}>
                {t.description?.substring(0, 120)}
                {t.description?.length > 120 ? '...' : ''}
              </p>
              <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                {t.createdBy?.name} · {t._count?.comments || 0} comentario(s)
              </div>
            </div>
            <span
              style={{
                padding: '4px 12px',
                borderRadius: 20,
                fontSize: 12,
                background:
                  t.status === 'OPEN'
                    ? '#4caf5033'
                    : t.status === 'IN_PROGRESS'
                      ? '#2196f333'
                      : t.status === 'RESOLVED'
                        ? '#ff980033'
                        : '#666633',
                color:
                  t.status === 'OPEN'
                    ? '#4caf50'
                    : t.status === 'IN_PROGRESS'
                      ? '#2196f3'
                      : t.status === 'RESOLVED'
                        ? '#ff9800'
                        : '#999',
              }}
            >
              {t.status === 'OPEN'
                ? 'Abierto'
                : t.status === 'IN_PROGRESS'
                  ? 'En Progreso'
                  : t.status === 'RESOLVED'
                    ? 'Resuelto'
                    : 'Cerrado'}
            </span>
          </div>
        ))}
        {tickets.length === 0 && (
          <p style={{ textAlign: 'center', color: '#888', padding: 40 }}>
            No hay tickets registrados
          </p>
        )}
      </div>
    </div>
  );
}
